import DeletePipeline from './DeletePipeline';

export default DeletePipeline;
